import { BoxProps, ButtonGroup } from '@mui/material'
import styled from 'styled-components'

interface BtnGroupProps extends BoxProps {
  isRoadMap?: boolean
}

export const MapTypeButtonGroup = styled(ButtonGroup).withConfig<BtnGroupProps>(
  {
    shouldForwardProp: (prop) => prop !== 'isRoadMap',
  },
)`
  position: absolute;
  bottom: 14px;
  left: 23px;
  display: flex;
  align-items: center;
  background: ${(props) =>
    props.isRoadMap ? 'rgba(142, 145, 143, 0.555)' : '#FFFFFF33'};
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  border-radius: 100px;
  padding: 4px 2px;

  .MuiButtonGroup-grouped {
    height: 27px;
    width: 80px;
    padding: 15px;
    font-weight: 600;
    font-size: 13px;
    line-height: 15px;
    border-radius: 100px;
    margin: 5px;
    &:not(:first-child) {
      margin-left: 3px;
    }
    &.MuiButton-contained {
      color: #ffffff;
      background-color: #004744;
    }
    background-color: rgba(255, 255, 255, 0.5);
    color: #000000;
    border: none;
  }
`

export default MapTypeButtonGroup
